/**
 * Каталог материалов стен. Штриховки — по ГОСТ-обозначениям материалов в разрезе,
 * поверхность — условные цвета для объёма.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { WallMaterial, type WallCatalogItem } from "./types";

export const wallSection: CatalogSection<WallCatalogItem> = {
	kind: LayerKind.Walls,
	label: "Стены",
	canChangeDimensions: false,
	subGroups: ["Материалы"],
	items: [
		{
			id: "wall-block",
			material: WallMaterial.Block,
			subGroup: "Материалы",
			name: "Блоки",
			description: "Газо- и пеноблоки — межкомнатные перегородки и ненесущие стены.",
			color: "#e2ded6",
			defaultThickness: 100,
			background: "#ffffff",
			stroke: "#39414f",
			angle: 45,
			spacing: 7,
			roughness: 0.95,
			opacity: 1,
		},
		{
			id: "wall-brick",
			material: WallMaterial.Brick,
			subGroup: "Материалы",
			name: "Кирпич",
			description: "Кирпичная кладка — несущие и наружные стены.",
			color: "#c2917c",
			defaultThickness: 250,
			background: "#ffffff",
			stroke: "#39414f",
			angle: 45,
			spacing: 4,
			roughness: 0.95,
			opacity: 1,
		},
		{
			id: "wall-concrete",
			material: WallMaterial.Concrete,
			subGroup: "Материалы",
			name: "Бетон",
			description: "Монолит и железобетонные панели.",
			color: "#c6cad0",
			defaultThickness: 200,
			background: "#f2f4f7",
			stroke: "#39414f",
			angle: 45,
			spacing: 8,
			dots: true,
			roughness: 0.9,
			opacity: 1,
		},
		{
			id: "wall-drywall",
			material: WallMaterial.Drywall,
			subGroup: "Материалы",
			name: "ГКЛ",
			description: "Гипсокартон на каркасе — лёгкие перегородки и короба.",
			color: "#eef1f4",
			defaultThickness: 100,
			background: "#ffffff",
			stroke: "#8d97a8",
			angle: 0,
			spacing: 5,
			roughness: 0.98,
			opacity: 1,
		},
		{
			id: "wall-wood",
			material: WallMaterial.Wood,
			subGroup: "Материалы",
			name: "Дерево",
			description: "Брус и деревянный каркас.",
			color: "#c39a69",
			defaultThickness: 120,
			background: "#fbf7f1",
			stroke: "#9a7f5c",
			angle: 90,
			spacing: 5,
			roughness: 0.75,
			opacity: 1,
		},
		{
			id: "wall-glass",
			material: WallMaterial.Glass,
			subGroup: "Материалы",
			name: "Стекло",
			description: "Стеклянные перегородки — в 3D прозрачные.",
			color: "#bcd8ea",
			defaultThickness: 50,
			background: "#e7f2fa",
			stroke: "#7fa8c4",
			angle: null,
			spacing: 7,
			roughness: 0.08,
			opacity: 0.3,
		},
		{
			id: "wall-other",
			material: WallMaterial.Other,
			subGroup: "Материалы",
			name: "Другой",
			description: "Материал не определён — нейтральная штриховка точками.",
			color: "#d9dce1",
			defaultThickness: 120,
			background: "#ffffff",
			stroke: "#39414f",
			angle: null,
			spacing: 7,
			dots: true,
			roughness: 0.9,
			opacity: 1,
		},
	],
};
